import React from 'react';
import PropTypes from 'prop-types';
import { tagStyle } from './helpers/styles';

const AccountAccessFieldTag = ({ selectedAccess, selectedAccessLevel }) => {
  const isLastInList =
    Array.isArray(selectedAccessLevel) &&
    selectedAccessLevel.findIndex((access) => {
      return access.value === selectedAccess.value;
    }) ===
      selectedAccessLevel.length - 1;
  const text = isLastInList
    ? selectedAccess.label
    : `${selectedAccess.label}, `;

  return (
    <div
      css={tagStyle}
      data-testid="AccountMemberProfilePanel_accountAccessFieldTag"
    >
      {text}
    </div>
  );
};

AccountAccessFieldTag.propTypes = {
  selectedAccess: PropTypes.object.isRequired,
  selectedAccessLevel: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    .isRequired,
};

export default AccountAccessFieldTag;
